<template>
  <div class="page flex-col">
    <div class="report-header flex-col">
      <span class="report-header_one">{{ $portalText('technicalReport', 't001') }}</span>
      <span class="report-header_two">{{ $portalText('technicalReport', 't002') }}</span>
    </div>
    <div class="report-middle flex-col">
      <div class="anrchor_class" id="report"></div>
      <div class="report-middle_box1 flex-row">
        <div class="middle_box1-image flex-row justify-between">
          <img class="box1-image_img" referrerpolicy="no-referrer" :src="decorationIcon" />
          <span class="box1-image_label">{{ $portalText('technicalReport', 't003') }}</span>
        </div>
      </div>
      <div class="report-middle_box2 flex-row justify-between">
        <div class="middle_box2-block1 flex-col justify-between">
          <div class="box2-block1_group1 flex-col">
            <span class="block1_group1_text1">{{ $portalText('technicalReport', 't004') }}</span>
            <span class="block1_group1_text2" style="white-space:pre-line">{{ $portalText('technicalReport', 't005') }}</span>
            <span
              class="block1_group1_text3">{{ $portalText('technicalReport', 't006') }}</span>
          </div>
          <div class="box2-block1_group2 flex-row justify-between"
            @click="downloadFile(reportUrl, '产品数字护照(DPP)技术发展报告')">
            <span class="block1_group2-text">{{ $portalText('technicalReport', 't007') }}</span>
            <div class="block1_group2-style flex-col">
              <img :src="arrowdownIcon" />
            </div>
          </div>
        </div>
      </div>
      <div class="report-middle_image flex-col">
        <img class="middle_image-img" referrerpolicy="no-referrer" :src="reportBackgroundTwoImg" />
      </div>
    </div>
    <div class="report-bottom flex-col">
      <div class="anrchor_class" id="digitalize"></div>
      <div class="report-bottom_image flex-row justify-between">
        <img class="bottom_image-img" referrerpolicy="no-referrer" :src="decorationIcon" />
        <span class="bottom_image-label">{{ $portalText('technicalReport', 't008') }}</span>
      </div>
      <div class="report-bottom_box flex-row justify-between">
        <div class="bottom_box-group flex-col justify-between">
          <div class="box-group_block flex-col">
            <span class="group_block-text1">{{ $portalText('technicalReport', 't009') }}</span>
            <span class="group_block-text2">{{ $portalText('technicalReport', 't010') }}</span>
            <span
              class="group_block-text3">{{ $portalText('technicalReport', 't011') }}</span>
          </div>
          <div class="box-group_block1 flex-row justify-between" @click="downloadFile(whitePaperUrl, '中国电池数字护照体系白皮书')">
            <span class="group_block1-text">{{ $portalText('technicalReport', 't012') }}</span>
            <div class="group_block1-style flex-col">
              <img :src="arrowdownIcon" />
            </div>
          </div>
        </div>
        <img class="bottom_box-img" referrerpolicy="no-referrer" :src="passportBackgroundImg" />
      </div>
    </div>
  </div>
</template>
<script>
import { portalData } from '@/portal/runtime';

import arrowdownIcon from '@/assets/images/technicalReport/arrow_down.png';
import decorationIcon from '@/assets/images/home/decoration.png';
import reportBackgroundOneImg from '@/assets/images/technicalReport/report_background_one.png';
import reportBackgroundTwoImg from '@/assets/images/technicalReport/report_background_two.png';
import passportBackgroundImg from '@/assets/images/technicalReport/passport_background.png';
export default {
  portalScope: 'technicalReport',
  data() {
    return portalData('technicalReport', {
      arrowdownIcon,
      decorationIcon,
      reportBackgroundOneImg,
      reportBackgroundTwoImg,
      passportBackgroundImg,
      reportUrl: `${process.env.BASE_URL}pdf/产品数字护照(DPP)技术发展报告.pdf`,
      whitePaperUrl: `${process.env.BASE_URL}pdf/中国电池数字护照体系白皮书.pdf`
    });
  },
  methods: {
    // 处理二进制流
    downloadFile(url, fileName) {
      let link = document.createElement('a');
      link.href = url;
      link.style.display = 'none';
      link.download = `${fileName}.pdf`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  },
};
</script>
<style lang="less" scoped>
@import url('./index.less');
</style>
